import React, { useRef } from "react";
import ReactDOM from "react-dom";
import useDropElement from "../../../hooks/use-drop-element";
import useOutsideClick from "../../../hooks/use-outside-click";
import useKeyboardEsc from "../../../hooks/use-keyboard-esc";
import Container from "./container";
import BackdropContainer from "./backdropContainer";
var emptyArray = [];
var Layer = function (_a) {
    var _b = _a.position, position = _b === void 0 ? "center" : _b, _c = _a.full, full = _c === void 0 ? false : _c, _d = _a.backdrop, backdrop = _d === void 0 ? true : _d, _e = _a.margin, margin = _e === void 0 ? emptyArray : _e, onClickOutside = _a.onClickOutside, onEsc = _a.onEsc, borderShadow = _a.borderShadow, children = _a.children, backdropProps = _a.backdropProps;
    var ref = useRef();
    useOutsideClick(ref, onClickOutside);
    useKeyboardEsc(onEsc);
    var el = useDropElement();
    var content = (React.createElement(Container, { isAbsolute: backdrop, ref: ref, full: full, position: position, margin: margin, borderShadow: borderShadow, "data-testid": "layer-container" }, children));
    return ReactDOM.createPortal(backdrop ? (React.createElement(BackdropContainer, { backdropProps: backdropProps }, content)) : (content), el);
};
export default Layer;
